import useTranslation from "next-translate/useTranslation";

export default function InjectMessage({ id }) {
  const { t: translation } = useTranslation();
  return <>{translation(id)}</>;
}
